/**
 * Auto generated file by Enso Devtools extension
 * using command: 'Generate the shared index file'
 * or when creating a new shared component
 * Manual changes will be overwritten
 */

import { App, Plugin } from 'vue';

import SharedAddButton from './SharedAddButton.vue';
import SharedAnnotation from './SharedAnnotation.vue';
import SharedAppAsideItem from './SharedAppAsideItem.vue';
import SharedAsideNavigation from './SharedAsideNavigation.vue';
import SharedButtonCard from './SharedButtonCard.vue';
import SharedCompanyFlatSelect from './SharedCompanyFlatSelect.vue';
import SharedDetailsDocumentHistory from './SharedDetailsDocumentHistory.vue';
import SharedDetailsListItem from './SharedDetailsListItem.vue';
import SharedDigitalSafeArboLabel from './SharedDigitalSafeArboLabel.vue';
import SharedDiscussions from './SharedDiscussions.vue';
import SharedDocumentSticker from './SharedDocumentSticker.vue';
import SharedFlatSelect from './SharedFlatSelect.vue';
import SharedFoldable from './SharedFoldable.vue';
import SharedGoogleAutoComplete from './SharedGoogleAutoComplete.vue';
import SharedGoogleMap from './SharedGoogleMap.vue';
import SharedLayout from './SharedLayout.vue';
import SharedListDocumentActions from './SharedListDocumentActions.vue';
import SharedListDocumentItemActions from './SharedListDocumentItemActions.vue';
import SharedListQuickFilter from './SharedListQuickFilter.vue';
import SharedLogoCompany from './SharedLogoCompany.vue';
import SharedLogoCompanyModal from './SharedLogoCompanyModal.vue';
import SharedMagneticBlob from './SharedMagneticBlob.vue';
import SharedMainNav from './SharedMainNav.vue';
import SharedMissionPlaceSelect from './SharedMissionPlaceSelect.vue';
import SharedOrderGroupSelect from './SharedOrderGroupSelect.vue';
import SharedOtpChannelPicker from './SharedOtpChannelPicker.vue';
import SharedPagedListActions from './SharedPagedListActions.vue';
import SharedPagedListOrderHeader from './SharedPagedListOrderHeader.vue';
import SharedPictoCard from './SharedPictoCard.vue';
import SharedProgressBar from './SharedProgressBar.vue';
import SharedRoleFlatSelect from './SharedRoleFlatSelect.vue';
import SharedRoleSelect from './SharedRoleSelect.vue';
import SharedSelectAgencyQualifications from './SharedSelectAgencyQualifications.vue';
import SharedSelectAssignee from './SharedSelectAssignee.vue';
import SharedSelectColor from './SharedSelectColor.vue';
import SharedSelectCompany from './SharedSelectCompany.vue';
import SharedSelectPictoCard from './SharedSelectPictoCard.vue';
import SharedSelectUserCompany from './SharedSelectUserCompany.vue';
import SharedSelectUserList from './SharedSelectUserList.vue';
import SharedSettingCard from './SharedSettingCard.vue';
import SharedStatCard from './SharedStatCard.vue';
import SharedStateIcon from './SharedStateIcon.vue';
import SharedStepper from './SharedStepper.vue';
import SharedTagDotsExpandable from './SharedTagDotsExpandable.vue';
import SharedTagFlatSelect from './SharedTagFlatSelect.vue';
import SharedTagQuickFilter from './SharedTagQuickFilter.vue';
import SharedTagSelect from './SharedTagSelect.vue';
import SharedToggle from './SharedToggle.vue';
import SharedUserListForRolesAndTags from './SharedUserListForRolesAndTags.vue';

export const sharedComponents: Plugin = {
	install (app: App<any>) {
		app.component('SharedAddButton', SharedAddButton);
		app.component('SharedAnnotation', SharedAnnotation);
		app.component('SharedAppAsideItem', SharedAppAsideItem);
		app.component('SharedAsideNavigation', SharedAsideNavigation);
		app.component('SharedButtonCard', SharedButtonCard);
		app.component('SharedCompanyFlatSelect', SharedCompanyFlatSelect);
		app.component('SharedDetailsDocumentHistory', SharedDetailsDocumentHistory);
		app.component('SharedDetailsListItem', SharedDetailsListItem);
		app.component('SharedDigitalSafeArboLabel', SharedDigitalSafeArboLabel);
		app.component('SharedDiscussions', SharedDiscussions);
		app.component('SharedDocumentSticker', SharedDocumentSticker);
		app.component('SharedFlatSelect', SharedFlatSelect);
		app.component('SharedFoldable', SharedFoldable);
		app.component('SharedGoogleAutoComplete', SharedGoogleAutoComplete);
		app.component('SharedGoogleMap', SharedGoogleMap);
		app.component('SharedLayout', SharedLayout);
		app.component('SharedListDocumentActions', SharedListDocumentActions);
		app.component('SharedListDocumentItemActions', SharedListDocumentItemActions);
		app.component('SharedListQuickFilter', SharedListQuickFilter);
		app.component('SharedLogoCompany', SharedLogoCompany);
		app.component('SharedLogoCompanyModal', SharedLogoCompanyModal);
		app.component('SharedMagneticBlob', SharedMagneticBlob);
		app.component('SharedMainNav', SharedMainNav);
		app.component('SharedMissionPlaceSelect', SharedMissionPlaceSelect);
		app.component('SharedOrderGroupSelect', SharedOrderGroupSelect);
		app.component('SharedOtpChannelPicker', SharedOtpChannelPicker);
		app.component('SharedPagedListActions', SharedPagedListActions);
		app.component('SharedPagedListOrderHeader', SharedPagedListOrderHeader);
		app.component('SharedPictoCard', SharedPictoCard);
		app.component('SharedProgressBar', SharedProgressBar);
		app.component('SharedRoleFlatSelect', SharedRoleFlatSelect);
		app.component('SharedRoleSelect', SharedRoleSelect);
		app.component('SharedSelectAgencyQualifications', SharedSelectAgencyQualifications);
		app.component('SharedSelectAssignee', SharedSelectAssignee);
		app.component('SharedSelectColor', SharedSelectColor);
		app.component('SharedSelectCompany', SharedSelectCompany);
		app.component('SharedSelectPictoCard', SharedSelectPictoCard);
		app.component('SharedSelectUserCompany', SharedSelectUserCompany);
		app.component('SharedSelectUserList', SharedSelectUserList);
		app.component('SharedSettingCard', SharedSettingCard);
		app.component('SharedStatCard', SharedStatCard);
		app.component('SharedStateIcon', SharedStateIcon);
		app.component('SharedStepper', SharedStepper);
		app.component('SharedTagDotsExpandable', SharedTagDotsExpandable);
		app.component('SharedTagFlatSelect', SharedTagFlatSelect);
		app.component('SharedTagQuickFilter', SharedTagQuickFilter);
		app.component('SharedTagSelect', SharedTagSelect);
		app.component('SharedToggle', SharedToggle);
		app.component('SharedUserListForRolesAndTags', SharedUserListForRolesAndTags);
	},
};
